import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { RestResponse } from "../classes/rest-response";
import { ApiHeaders } from "../classes/api-headers";

@Injectable()
export class MainProvider {
  baseUrl: string = environment.BASE_URL;
  baseUrl2: string = environment.BASE_URL2;

  constructor(private http: HttpClient) {
  }

  // Old APIs

  logoutAdmin(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AdminUpdate`, formData);
  }

  AdminControl(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AdminControl`, formData);
  }

  getEmployeeList(searchKey: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/Employee/EmployeeAllList?SearchTerm=${searchKey}`, ApiHeaders.getOptions());
  }

  getHODList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/Employee/HODEmployeeAllList`, ApiHeaders.getOptions());
  }

  getReportingToList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/Employee/ReportingEmployeeAllList`, ApiHeaders.getOptions());
  }

  addEmployeeInfo(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/Employee/AddEmployeeInfo`, saveObj, ApiHeaders.getOptions());
  }

  addEmployeePersonalInfo(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/Employee/AddEmployeePersonalDetail`, saveObj, ApiHeaders.getOptions());
  }

  addEmployeeBankInfo(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/Employee/AddEmployeeBankDetails`, saveObj, ApiHeaders.getOptions());
  }

  addEmployeeQualification(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/Employee/AddEmpQualification`, saveObj, ApiHeaders.getOptions());
  }

  addEmployeeWorkExp(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/Employee/AddEmpWorkExperience`, saveObj, ApiHeaders.getOptions());
  }

  addEmployeeAttechment(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/Employee/EmployeeDocumentUpload`, formData);
  }

  getEmployeeQualification(employeeId: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/Employee/GetEmpQualificationListByUserId?UserId=${employeeId}`, ApiHeaders.getOptions());
  }

  getEmployeeWorkExp(employeeId: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/Employee/GetEmpWorkExperienceListByUserId?UserId=${employeeId}`, ApiHeaders.getOptions());
  }

  getEmployeePersonalInfoAndPayment(employeeId: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/Employee/EmployeeDetail?Id=${employeeId}`, ApiHeaders.getOptions());
  }

  AddTask(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AddTask`, formData);
  }

  TaskList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/TaskList`, formData);
  }

  TaskDelete(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/TaskDelete`, formData);
  }

  TaskDetailsList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/TaskDetailsList`, formData);
  }

  OrderList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/OrderList`, formData);
  }

  OrderUpdate(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/OrderUpdate`, formData);
  }

  ItemCancel(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/ItemCancel`, formData);
  }

  OrderListReport(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/OrderListReport`, formData);
  }

  GetAttendanceData(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/GetAttendanceData`, formData);
  }

  UpdateAttendance(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/UpdateAttendance`, formData);
  }

  NotificationList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/NotificationList`, formData);
  }

  AddEditNotification(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AddEditNotification`, formData);
  }

  NotificationDelete(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/NotificationDelete`, formData);
  }

  PushNotificationUser(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl2 + `/PushNotificationUser`, formData);
  }

  AdminDashboard(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AdminDashboard`, formData);
  }

  AdminDashboard2(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AdminDashboard2`, formData);
  }

  ApplicationControl(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/ApplicationControl`, formData);
  }

  ApplicationControlUpdate(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/ApplicationControlUpdate`, formData);
  }

  FindLastPriceVendorWise(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/FindLastPriceVendorWise`, formData);
  }

  UpdateLastPrice(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/UpdateLastPrice`, formData);
  }

  TaskImageUnlink(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/TaskImageUnlink`, formData);
  }

  // Dashboard

  getDashboardGraphData(fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getDashboardGraph?fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  getDashboardSummary(fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getDashboardSummary?fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  // Expense
  getExpenseList(id: number, fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getExpance?id=${id}&fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  addEditExpense(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/addEditExpance`, saveObj, ApiHeaders.getOptions());
  }

  getExpenseReportList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/GetExpenseReport`, formData);
  }

  // Admin API

  getPartnersList(id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getAdmin?id=${id}`, ApiHeaders.getOptions());
  }

  updateAdminPassword(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/updateAdminPassword`, saveObj, ApiHeaders.getOptions());
  }

  //  Supplier API

  getSupplierList(id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getSupplier?id=${id}`, ApiHeaders.getOptions());
  }

  addEditSupplier(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/addEditSupplier`, saveObj, ApiHeaders.getOptions());
  }

  //  Client API

  getClientsList(id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getClient?id=${id}`, ApiHeaders.getOptions());
  }

  addEditClients(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/addEditClient`, saveObj, ApiHeaders.getOptions());
  }

  //  Items API

  getItemsList(id: number, type: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getItem?id=${id}&type=${type}`, ApiHeaders.getOptions());
  }

  getUnitList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getUnit`, ApiHeaders.getOptions());
  }

  addEditItems(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/addEditItem`, saveObj, ApiHeaders.getOptions());
  }

  //  Ledgers API

  getLedgerList(id: number, type: string, typeId: number, fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getLedger?id=${id}&type=${type}&typeid=${typeId}&fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  addEditLedger(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/addEditLedger`, saveObj, ApiHeaders.getOptions());
  }

  getBankList(id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getBank?id=${id}`, ApiHeaders.getOptions());
  }

  getAdminList(id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getAdmin?id=${id}`, ApiHeaders.getOptions());
  }

  // Billing API

  getBillingList(id: number, supplierId: number, fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getBill?id=${id}&supplierid=${supplierId}&fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  addEditBill(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/saveSupplierBill`, saveObj, ApiHeaders.getOptions());
  }

  billStatusChange(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/billStatusChange`, saveObj, ApiHeaders.getOptions());
  }

  getGST(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getGST`, ApiHeaders.getOptions());
  }

  // Purchase Order API

  getPOList(id: number, clientId: number, adminId: number, ponumber: string, fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getPO?id=${id}&clientid=${clientId}&adminid=${adminId}&ponumber=${ponumber}&fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  addEditPO(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/saveClientPO`, saveObj, ApiHeaders.getOptions());
  }

  poStatusChange(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/POStatusChange`, saveObj, ApiHeaders.getOptions());
  }

  // Invoice API

  getInvoiceList(id: number, clientId: number, adminId: number, invoicenumber: string, fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getInvoice?id=${id}&clientid=${clientId}&adminid=${adminId}&invoicenumber=${invoicenumber}&fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  addEditInvoice(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/saveClientInvoice`, saveObj, ApiHeaders.getOptions());
  }

  invoiceStatusChange(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/invoiceStatusChange`, saveObj, ApiHeaders.getOptions());
  }

  // Event Schedule API

  getEventSchedule(fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getEventSchedule?fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  // Reports APIs

  getEquityReport(fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/getEquityReports?fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  getLiveEquityReport(fromDate: string, toDate: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/liveEquityReports?fromdate=${fromDate}&todate=${toDate}`, ApiHeaders.getOptions());
  }

  // New APIs
  // LogOut User

  logoutUser(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserLogout`, obj, ApiHeaders.getOptions());
  }

  // Admin Password Change

  appUserUpdatePassword(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserUpdatePassword`, saveObj, ApiHeaders.getOptions());
  }

  // City API

  getUserCityList(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserCity`, saveObj, ApiHeaders.getOptions());
  }

  addEditUserCity(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserCityAddAndUpdate`, saveObj, ApiHeaders.getOptions());
  }

  // Category and Product API

  getUserCategoryandProduct(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserCategoryAndProduct`, saveObj, ApiHeaders.getOptions());
  }

  addEditCategory(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserCategoryAddAndUpdate`, saveObj, ApiHeaders.getOptions());
  }

  addEditProduct(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserProductAddAndUpdate`, saveObj, ApiHeaders.getOptions());
  }

  // App User API

  getAppUserList(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserList`, saveObj, ApiHeaders.getOptions());
  }

  getAppUserRoles(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserRole`, saveObj, ApiHeaders.getOptions());
  }

  addEditUserData(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserAddAndUpdate`, saveObj, ApiHeaders.getOptions());
  }

  addEditUserExpense(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserExpenseAddUpdate`, saveObj, ApiHeaders.getOptions());
  }

  getUserExpenseData(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserExpenseList`, saveObj, ApiHeaders.getOptions());
  }

  // Users Task API

  getUserTaskList(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserTaskList`, saveObj, ApiHeaders.getOptions());
  }

  addEditUserTask(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserTaskAddAndUpdate`, saveObj, ApiHeaders.getOptions());
  }

  userTaskStatusUpdate(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserTaskStatusUpdate`, saveObj, ApiHeaders.getOptions());
  }

  userLocationLog(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserLocationList`, saveObj, ApiHeaders.getOptions());
  }

  appUserTaskAmountUpdate(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserTaskAmountUpdate`, saveObj, ApiHeaders.getOptions());
  }

  appUserTaskAmountPaid(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserTaskAmountPaid`, saveObj, ApiHeaders.getOptions());
  }

  // User Notification API

  getNotificationList(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserNotificationList`, saveObj, ApiHeaders.getOptions());
  }

  addEditUserNotification(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserNotificationAddandUpdate`, saveObj, ApiHeaders.getOptions());
  }

  sendUserNotification(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserNotificationSend`, saveObj, ApiHeaders.getOptions());
  }

  // User Dashboard API

  appUserDashboardData(saveObj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/appUserDashboardCount`, saveObj, ApiHeaders.getOptions());
  }

}
